import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { BodyTitle } from '../../components/bakery/styleds'
import FarmCards from './components/FarmCards'
import { MINTTOKEN } from '../../constants/bakery'
import { useWalletModalToggle } from '../../state/application/hooks'
import { useActiveWeb3React } from '../../hooks'
import { ButtonPrimary } from '../../components/Button'

const BodyHead = styled.div`
  color: ${({theme}) => theme.bsText3};
  text-align: center;
  margin-bottom: 50px;
`
const LoginBtn = styled(ButtonPrimary)`
  margin: 54px auto 0;
  width: initial;
  padding: 8px 16px;
`
const LoginBtnWrapper = styled.div``
export default function MyEggs () {
  const curTab = MINTTOKEN.TEN
  const { active, account } = useActiveWeb3React()
  const { t } = useTranslation()
  const toggleWalletModal = useWalletModalToggle()
    return (
    <>
      {!(active && account) ?
        (
          <LoginBtnWrapper>
            <LoginBtn onClick={toggleWalletModal}>{t('Connect to a wallet')}</LoginBtn>
          </LoginBtnWrapper>
        )
        : <>
          <BodyHead>
            <BodyTitle fontSize={32} fontWeight={700}>
              Spring Festival
            </BodyTitle>
          </BodyHead>
          
          <FarmCards tokenName={curTab}/>
      </>
      }
    </>
  )
}